(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-elig-corp', {
            parent: 'entity',
            url: '/prog-elig-corp',
            data: {
                authorities: [],
                pageTitle: 'ProgEligCorps'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-elig-corp/prog-elig-corps.html',
                    controller: 'ProgEligCorpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access);
            }]
        })
        .state('prog-elig-corp.new', {
            parent: 'prog-elig-corp',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-dialog.html',
                        controller: 'ProgEligCorpDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('prog-elig-corp');
                    });
                }
            }]
        })
        .state('prog-elig-corp.edit', {
            parent: 'prog-elig-corp',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-dialog.html',
                        controller: 'ProgEligCorpDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['ProgEligCorp', function (ProgEligCorp) {
                                return ProgEligCorp.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-elig-corp.delete', {
            parent: 'prog-elig-corp',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-delete-dialog.html',
                        controller: 'ProgEligCorpDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['ProgEligCorp', function (ProgEligCorp) {
                                return ProgEligCorp.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();
